import { render, staticRenderFns } from "./rental-publish.vue?vue&type=template&id=61158f14&scoped=true&"
import script from "./rental-publish.vue?vue&type=script&lang=js&"
export * from "./rental-publish.vue?vue&type=script&lang=js&"
import style0 from "./rental-publish.vue?vue&type=style&index=0&id=61158f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61158f14",
  null
  
)

export default component.exports